<template>
  <div v-if="isShowPage" class="edit-user">
    <van-nav-bar
      class="nav-edit"
      v-if="isAgentInformation == 1"
      @click-right="goModify"
      :right-text="userInfo.isPropertyAgent && agentBox ? lang.modify : ''"
      :title="lang.agentInformation"
      left-arrow
      @click-left="onClickLeftAgent"
    />
    <van-nav-bar class="nav-edit" v-if="isAgentInformation == 2" :title="lang.deleteAccount" left-arrow @click-left="onClickLeftDelete" />
    <van-nav-bar v-if="isAgentInformation == 0" :title="lang.changeMemberProfile" :left-arrow="!$route.query.fromapp" @click-left="onClickLeft" />
    <div class="user" v-if="isAgentInformation == 0">
      <!-- 用户基本资料 -->
      <div class="user-detail">
        <!-- 头像 -->
        <van-cell class="user-img" :title="lang.userPicture">
          <img @click="editUserPic = true" :src="userInfo.imagePath | imgResize('user')" onerror="errorImg(this,'user')" alt />
          <van-icon name="arrow" />
        </van-cell>
        <!-- 设置密码 修改密码 -->
        <van-cell
          :class="{ 'no-password': !userInfo.isSetPassWord }"
          @click="userInfo.isSetPassWord ? goPage('edit-password') : goPage('set-password')"
          :title="lang.password"
          is-link
          :value="userInfo.isSetPassWord ? '********' : lang.setPassword"
        />
        <!-- 邮箱  -->
        <van-cell
          :class="{ 'no-password': !userInfo.email }"
          @click="userInfo.email ? (editEmailNotice = true) : goPage('set-email')"
          :title="lang.email"
          is-link
          :value="!userInfo.email ? lang.join : userInfo.email"
        />
        <!-- 手提电话 -->
        <van-cell @click="goPage('edit-telephone')" :title="lang.cellPhone" is-link :value="userInfo.telephone" />
        <!-- 用户名 -->
        <van-cell @click="editNameShow = true" :title="lang.memberName" is-link :value="userInfo.nickName ? userInfo.nickName : ''" />
        <!-- 隐藏接收通讯栏 -->
        <!-- <van-switch-cell @change="changeSwitch" class="switch-select" v-model="userInfo.isReceiveMessage" :title="lang.acceptInformation" active-color="#FF0000" /> -->
        <van-switch-cell @change="changeSwitch" class="switch-select" v-model="userInfo.isReceiveSMS" :title="lang.acceptSMS" active-color="#FF0000" />
      </div>
      <!-- 进入代理部分 -->
      <div class="agent">
        <van-cell :title="lang.estateAgent" active-color="#FF0000" @click="isAgentClick()" is-link />
      </div>
      <div class="delete-user" @click="deleteUser">{{lang.deleteAccount}}</div>
    </div>
    <!-- 代理部分 -->
    <div class="agency" v-if="isAgentInformation == 1">
      <!-- 展示部分 -->
      <div v-if="agentBox" class="show-detail">
        <!-- 代理人头像信息 -->
        <div class="user-card">
          <div class="user-pic">
            <img :src="userInfo.imagePath | imgResize('user')" onerror="errorImg(this,'user')" alt />
          </div>
          <div class="user-card-detail">
            <div class="user-name">{{ userInfo.nickName }}</div>
            <div class="company-name">{{ userInfo.companyNameCN }}</div>
            <div class="company-num">{{ userInfo.license }}</div>
          </div>
        </div>
        <!-- 代理人签名 -->
        <div v-if="userInfo.signature" class="user-license">
          {{ userInfo.signature }}
        </div>
        <!-- 代理人公司信息 -->
        <div class="agent-detail">
          <van-cell :title="lang.realEstateAgency" size="large" :label="userInfo.companyNameCN" />
          <van-cell v-if="userInfo.companyNameEN" :title="lang.realEstateAgencyEN" size="large" :label="userInfo.companyNameEN" />
          <van-cell :title="lang.realEstateAgencyPhone" size="large" :label="userInfo.companyTelephone" />
          <van-cell v-if="userInfo.companyAddress" :title="lang.realEstateAgencyAddress" size="large" :label="userInfo.companyAddress" />
          <van-cell :title="lang.estateAgencyLicense" size="large" :label="userInfo.companyLicense" />
          <van-cell :title="lang.personalAstateAgencyLicense" size="large" :label="userInfo.license" />
          <van-cell class="company-img">
            <template #title>
              <div class="custom-title">{{ lang.agentCard }}</div>
              <div class="company-tips">{{ lang.companyTips }}</div>
              <!-- <van-tag type="danger">标签</van-tag> -->
            </template>
            <img :src="userInfo.agentCardPath | imgResize('agent')" onerror="errorImg(this,'agent-company')" alt />
            <van-icon name="arrow" />
          </van-cell>
          <van-cell :title=" lang.agentCardTime" size="large" :label="agentInfo.agentCardExpireTime && agentInfo.agentCardExpireTime >0? new Date(parseInt(agentInfo.agentCardExpireTime ) * 1000).toLocaleDateString():''" />
        </div>
      </div>
      <!-- 修改部分 -->
      <div v-else class="edit-detail">
        <!-- 代理公司名称 -->
        <div class="input-title"><span class="red">*</span>{{ lang.realEstateAgency }}</div>
        <!-- :disabled="userInfo.companyNameCN"  :disabled="userInfo.companyNameEN" -->
        <van-field v-model="agentInfo.companyNameCN" maxlength="50" :placeholder="lang.pleaseFillOut" :disabled="disabledTextCN" />
        <div class="input-title"><span class="red"></span>{{ lang.realEstateAgencyEN }}</div>
        <van-field v-model="agentInfo.companyNameEN" maxlength="100" :placeholder="lang.pleaseFillOut" :disabled="disabledTextEN" />
        <!-- 代理公司电话 -->
        <div class="input-title"><span class="red">*</span>{{ lang.realEstateAgencyPhone }}</div>
        <!-- :disabled="userInfo.companyTelephone" -->
        <van-field v-model="agentInfo.companyTelephone" maxlength="8" @input="checkInt('companyTelephone', 1)" :placeholder="lang.pleaseFillOut" />
        <!-- 代理公司地址 -->
        <!-- <span class="red">*</span> -->
        <div class="input-title">{{ lang.realEstateAgencyAddress }}</div>
        <!-- :disabled="userInfo.companyAddress" -->
        <van-field v-model="agentInfo.companyAddress" maxlength="50" :placeholder="lang.pleaseFillOut" />
        <!-- 代理签名 -->
        <div class="input-title"><span class="red">*</span>{{ lang.estateAgencyLicense }}</div>
        <!--  :disabled="userInfo.companyLicense" -->
        <van-field v-model="agentInfo.companyLicense" maxlength="20" :placeholder="lang.pleaseFillOut" />
        <!-- 个人签名 -->
        <div class="input-title"><span class="red">*</span>{{ lang.personalAstateAgencyLicense }}</div>
        <van-field v-model="agentInfo.license" :disabled="userInfo.license" maxlength="20" :placeholder="lang.pleaseFillOut" />
        <!-- 个人介绍备注 -->
        <div class="input-title">{{ lang.personalAgentSignature }}</div>
        <div class="textarea">
          <!-- :disabled="userInfo.signature" -->
          <textarea v-model="agentInfo.signature" maxlength="200" :placeholder="lang.enterNote"></textarea>
          <span class="textarea-num">200</span>
        </div>
        <div class="div-line"></div>
        <!-- 上传图片  -->
        <div class="agent-pic">
          <van-uploader :after-read="afterRead" :max-size="5242880" accept="image/jpeg,image/jpg,image/png" @oversize="oversize" :disabled="userInfo.agentCardPath ? true : false">
            <van-cell>
              <template #title>
                <div><span class="red">*</span>{{ lang.agentCard }}</div>
                <p class="agent-notice">{{ lang.notice }}</p>
                <p>{{ lang.notice1 }}</p>
              </template>
              <!-- @click="clickUploaderAgent" -->
              <div v-if="!agentInfo.agentCardPath" class="img-bg"></div>
              <img v-else :src="agentInfo.agentCardPath | imgResize('agent')" onerror="errorImg(this,'agent-company')" alt />
              <!-- 原生方法 -->
              <!-- <input type="file" id="up-agent-input" class="up-agent-input" accept="image/jpeg,image/jpg,image/png" @change="uploaderAgent($event)" /> -->
              <van-icon name="arrow" />
            </van-cell>
          </van-uploader>
        </div>
        <div class="div-line"></div>
        <div class="agent-time">
          <van-cell style="padding: 15px"  @click="judgeTime">
              <template slot="title">
                <div >
                  <span class="red">*</span>
                  <span style="font-size: 15px; color: #333333; line-height: 21px; display: inline-block">{{ lang.agentCardTime }}</span>
                </div>
                <div>                  
                  <span :class="[{ fcolor:!agentInfo.agentCardExpireTime || agentInfo.agentCardExpireTime <0}]">{{ agentInfo.agentCardExpireTime && agentInfo.agentCardExpireTime >0? new Date(parseInt(agentInfo.agentCardExpireTime ) * 1000).toLocaleDateString():lang.pleSelect }}</span>
                </div>
              </template>
              <template slot="default">
                <div @click.stop>
                  <van-popup v-model="showPopup"  class="popup" position="bottom"  @click-overlay="showPopup = false" :close-on-click-overlay="true">
                    <van-datetime-picker
                    v-model="agentCardExpireTime"
                    type="date"
                    @confirm="confirmAgenTime"
                    @cancel="cancelAgenTime" 
                    :confirm-button-text="lang.confirm"
                  />
                  </van-popup>
                </div>
                <div class="agentcontent">
                  <van-icon class="fcolor" name="arrow" />
                </div>
              </template>
          </van-cell>
        </div>
        <div class="div-line"></div>
        <!-- 提交更改 -->
        <div class="btn-sub">
          <van-button :disabled="isClickEditAgent ? false : true" type="danger" @click="submitEdit" size="large">{{ lang.submit }}</van-button>
        </div>
      </div>
    </div>
    <!-- 删除账户 -->
    <div v-if="isAgentInformation == 2" class="delete-page">
      <div class="delete-page-title">{{lang.deletePageTitle}}</div>
      <div class="delete-page-info">{{lang.deletePageInfo1}}</div>
      <div class="delete-page-info" style="margin-top: 24px;margin-bottom: 44px;">{{lang.deletePageInfo2}}</div>
      <div class="confirm-delete" @click="confirmDelte">{{lang.deleteBtnText}}</div>
    </div>
    <!-- 上传图片预览剪切 -->
    <van-popup :overlay="false" class="edit-up-pic" v-model="editUpPic">
      <van-nav-bar :title="lang.confirmPhoto" left-arrow @click-left="editUpPic = false" />
      <div class="avatar-cropper-container">
        <div class="width-height">
          <vueCropper :fixed="true" :autoCrop="true" ref="cropper" :img="file" :outputSize="1" outputType="png"></vueCropper>
        </div>
      </div>
      <div class="btn-edit-pic">
        <van-button type="primary" @click="editUpPic = false" class="cancel">{{ lang.cancel }}</van-button>
        <van-button type="primary" @click="clickEditPic" class="comfrim">{{ lang.confirm1 }}</van-button>
      </div>
    </van-popup>
    <!-- 上传图片修改框 -->
    <van-popup v-model="editUserPic" position="bottom" class="edit-pic">
      <!-- 上传图片限制 image/png, image/jpeg, image/jpg-->
      <!-- 原生上传图片测试 -->
      <!-- <div class="new-img-uploader">
        <van-button type="primary" @click="clickUploaderPicture" class="choose" block>
          {{ lang.choosePic }}
        </van-button>
        <input type="file" id="up-img-input" class="up-img-input" accept="image/jpeg,image/jpg,image/png" @change="uploaderPicture($event)" />
      </div> -->
      <!-- 上传图片 flutter -->
      <van-uploader class="uploader" :after-read="afterReadLocal" :max-size="5242880" accept="image/jpeg,image/jpg,image/png" @oversize="oversize">
        <van-button type="primary" class="choose" block>
          {{ lang.choosePic }}
        </van-button>
      </van-uploader>
      <!-- 移除图片 -->
      <van-button @click="clickRemovePic" type="primary" class="remove" block>{{ lang.removePic }}</van-button>
      <van-button @click="editUserPic = false" type="primary" class="cancel" block>{{ lang.cancel }}</van-button>
    </van-popup>
    <!-- 弹出框 -->
    <van-dialog :confirmButtonText="lang.confirm1" :closeOnClickOverlay="true" @confirm="editUserName" class="edit-user-name" v-model="editNameShow" :title="lang.editUserName">
      <van-field maxlength="10" v-model="editNameValue" :placeholder="lang.editNameNoitce" />
      <!--  -->
    </van-dialog>
    <!-- 邮箱提示弹窗 -->
    <van-dialog :confirmButtonText="lang.confirm1" :closeOnClickOverlay="true" class="edit-email-notice" v-model="editEmailNotice">
      <p>{{ lang.editEmailNotice }}</p>
    </van-dialog>
  </div>
</template>
<script>
import pub from '../../common/public';
import { Cell, NavBar, List, Field, Notify, Uploader, Toast, Dialog } from 'vant';
import { mapState, mapMutations } from 'vuex';
import { VueCropper } from 'vue-cropper';
import lang from './../../common/language/editUser';
export default {
  name: 'edit-user',
  components: {
    VueCropper,
  },
  data() {
    return {
      disabledTextCN: false,
      disabledTextEN: false,
      isFirstTime:false,
      agentCardExpireTime:new Date(),
      showPopup:false,
      numFlag: 0,
      deleteFlag: false,
      isShowPage: false,
      isPc: false,
      fromapp: '',
      file: '',
      fileName: '',
      editUpPic: false,
      editEmailNotice: false,
      isClickEditAgent: false,
      isShowEditAgent: false,
      editNameValue: '',
      editNameShow: false,
      editUserPic: false,
      cacheNum: '',
      lang: lang,
      isShowEdit: true,
      userInfo: {},
      agentInfo: {
        companyNameCN: '',
        companyNameEN: '',
        companyTelephone: '',
        companyAddress: '',
        companyLicense: '',
        license: '',
        signature: '',
        agentCardPath: '',
        agentCardExpireTime:'',
      },
      agentBox: false,
      isAgentInformation: 0,
    };
  },
  watch: {
    agentInfo: {
      handler(val) {
        if (val.companyNameCN && val.companyTelephone && val.companyLicense && val.license && val.agentCardPath && val.agentCardExpireTime && val.agentCardExpireTime >0) this.isClickEditAgent = true;
        else this.isClickEditAgent = false;
      },
      
      deep: true,
    },
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (this.isAgentInformation == 0) {
        if (pub.getLang() === 'zh-cn') {
          location.href = `${pub.config.pcPassport}zh-cn/changeuserinfo/`;
        } else if (pub.getLang() === 'en-us') {
          location.href = `${pub.config.pcPassport}en-us/changeuserinfo/`;
        } else {
          location.href = `${pub.config.pcPassport}changeuserinfo/`;
        }
      } else if (this.isAgentInformation == 1) {
        if (pub.getLang() === 'zh-cn') {
          location.href = `${pub.config.pcPassport}zh-cn/changeagentinfo/`;
        } else if (pub.getLang() === 'en-us') {
          location.href = `${pub.config.pcPassport}en-us/changeagentinfo/`;
        } else {
          location.href = `${pub.config.pcPassport}changeagentinfo/`;
        }
      }
    } else {
      this.isShowPage = true;
    }
    this.getUserInfo();
    if (this.$route.query.fromapp) this.fromapp = this.$route.query.fromapp;
  },
  mounted() {
    // console.log("agentinfo:",this.agentInfo,"userinfo:",this.userInfo)
  },
  methods: {
    judgeTime(){
      if(this.isFirstTime){
      // if(this.agentInfo.agentCardExpireTime>0){
        return
      }else{
        this.showPopup=true
      }
    },
    cancelAgenTime(){
      this.showPopup = false
    },
    confirmAgenTime(value){
      this.showPopup = false
      this.agentInfo.agentCardExpireTime = parseInt(value.getTime() / 1000)+86399;
    },
    /**上传图片事件 */
    clickUploaderPicture() {
      document.querySelector('#up-img-input').click();
    },
    /**上传头像剪切 */
    uploaderPicture(e) {
      if (!e.target.files) {
        e.target.value = null;
        return;
      }
      let file = e.target.files[0];
      if (file.size && file.size < 20480) {
        e.target.value = null;
        this.editUserPic = false;
        this.$notify(lang.fileBig2);
        return;
      }
      if (!file.size || file.size > 5242880) {
        e.target.value = null;
        this.editUserPic = false;
        this.$notify(lang.fileBig);
        return;
      }
      this.fileName = file.name;
      this.file = URL.createObjectURL(file);
      if (this.validateFile(file)) {
        this.editUpPic = true;
        this.editUserPic = false;
      } else {
        this.editUserPic = false;
        this.$notify(lang.fileError);
      }
      /**清空 触发事件 */
      e.target.value = null;
    },
    /**上传代理证书 */
    clickUploaderAgent() {
      document.querySelector('#up-agent-input').click();
    },
    uploaderAgent(e) {
      if (!e.target.files) {
        e.target.value = null;
        return;
      }
      let file = e.target.files[0];
      if (file.size && file.size < 20480) {
        e.target.value = null;
        this.$notify(lang.fileBig2);
        return;
      }
      if (!file.size || file.size > 5242880) {
        e.target.value = null;
        this.$notify(lang.fileBig);
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      if (this.validateFile(file)) {
        /**上传代理证 图片 */
        this.axios
          .post(this.pub.getApi().Upload, formData)
          .then((res) => {
            if (res.data.code === 0 && res.data.result) {
              this.agentInfo.agentCardPath = res.data.result[0].url;
            } else {
              this.$notify(lang.picfailure);
            }
          })
          .catch((e) => {
            /**上传失败 */
            this.$notify(lang.picfailure);
          });
      } else {
        this.$notify(lang.fileError);
      }
      /**清空 触发事件 */
      e.target.value = null;
    },
    /**跳转页面 */
    goPage(data) {
      if (this.fromapp) this.$router.push(`/${data}/?fromapp=${this.fromapp}`);
      else this.$router.push(`/${data}/`);
    },
    /**剪切成功后上传 */
    clickEditPic() {
      this.$refs.cropper.getCropBlob((data) => {
        const file = new Blob([data], { type: data.type });
        const formdata = new FormData();
        formdata.append('file', file, this.fileName);
        /**上传图片 */
        this.axios
          .post(this.pub.getApi().Upload, formdata)
          .then((res) => {
            if (res.data.code === 0 && res.data.result) {
              /**直接修改头像 */
              this.axios
                .post(this.pub.getApi().UpdateUser, {
                  imagePath: res.data.result[0].url,
                })
                .then((resdata) => {
                  /**修改成功 */
                  if (resdata.data.code == 0) {
                    this.userInfo.imagePath = res.data.result[0].url;
                    this.editUserPic = false;
                    this.editUpPic = false;
                  } else {
                    this.$notify(lang.editFailure);
                  }
                });
            } else {
              this.$notify(lang.picfailure);
            }
          })
          .catch((e) => {
            this.$notify(lang.picfailure);
          });
      });
    },
    /**本地获取浏览图片 */
    afterReadLocal(file) {
      /**限制图片大小 */
      if (file.file.size && file.file.size < 20480) {
        this.editUserPic = false;
        this.$notify(lang.fileBig2);
        return;
      }
      this.fileName = file.file.name;
      this.file = URL.createObjectURL(file.file);
      if (this.validateFile(file.file)) {
        this.editUpPic = true;
        this.editUserPic = false;
      } else {
        this.editUserPic = false;
        this.$notify(lang.fileError);
      }
    },
    //验证头像格式
    validateFile(file) {
      const isJpg = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
      return isJpg;
    },
    /**获取用户信息 */
    getUserInfo() {
      /**获取个人信息 */
      this.axios.get(this.pub.getApi().GetUserInfo).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          this.userInfo = res.data.result;
          this.agentBox = res.data.result.isPropertyAgent;
          this.agentInfo.isPropertyAgent = res.data.result.isPropertyAgent;
          this.agentInfo.companyNameCN = res.data.result.companyNameCN;
          this.agentInfo.companyNameEN = res.data.result.companyNameEN;
          this.agentInfo.companyTelephone = res.data.result.companyTelephone;
          this.agentInfo.companyAddress = res.data.result.companyAddress;
          this.agentInfo.companyLicense = res.data.result.companyLicense;
          this.agentInfo.license = res.data.result.license;
          this.agentInfo.signature = res.data.result.signature;
          this.agentInfo.agentCardPath = res.data.result.agentCardPath || '';
          this.agentInfo.agentCardExpireTime =res.data.result.agentCardExpireTime || '';
          if (this.agentInfo.companyNameCN && this.agentInfo.companyNameCN.length > 0) {
            this.disabledTextCN = true
          } else {
            this.disabledTextCN = false
          }
          if (this.agentInfo.companyNameEN && this.agentInfo.companyNameEN.length > 0) {
            this.disabledTextEN = true
          } else {
            this.disabledTextEN = false
          }
          if( this.agentInfo.agentCardExpireTime && this.agentInfo.agentCardExpireTime>0){
            this.agentCardExpireTime = new Date(new Date(parseInt(this.agentInfo.agentCardExpireTime) * 1000).toLocaleDateString());
            this.isFirstTime = true
          }
        } else if (res.data.code == 101 || res.data.code == 100) {
          this.pub.delCookie('ERnJaMWtkM');
          this.pub.delCookie('cEVaUDFrZ1kd0RA');
          /**跳转页面 */
          if (navigator.userAgent.indexOf('house730') > -1) {
            let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
            const isFlutter = navigator.userAgent.indexOf('flutter') > -1;
            if (isFlutter) {
              window.house730.postMessage(JSON.stringify({ type: 'jumpLogin', data: {} }));
            } else if (isAndroid) {
              window.house730.jumpLogin();
            } else {
              window.webkit.messageHandlers.jumpLogin.postMessage(JSON.stringify({}));
            }
          } else {
            this.$router.push('/login/');
          }
        }
      });
    },
    /**打開修改代理人資料 */
    goModify() {
      this.agentBox = false;
    },
    /**修改用户名 */
    editUserName() {
      /**去掉空格 验证用户名格式 */
      this.editNameValue = this.editNameValue.trim();
      if (!this.editNameValue) return;
      if (!/^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(this.editNameValue)) {
        this.$notify(lang.editNameNoitce);
        this.editNameValue = '';
        return;
      }
      /**正则验证输入字符 */
      this.axios
        .post(this.pub.getApi().UpdateUser, {
          nickName: this.editNameValue,
        })
        .then((resdata) => {
          if (resdata.data.code == 0) {
            this.userInfo.nickName = this.editNameValue;
          } else {
            this.$notify(lang.editFailure);
          }
        });
    },
    /**点击移除相册按钮 */
    clickRemovePic() {
      this.editUserPic = false;
      Dialog.confirm({
        title: lang.removePicTitle,
        message: lang.isConfirm,
        confirmButtonColor: '#F73343',
        confirmButtonText: lang.confirm1,
        cancelButtonColor: '#333',
        cancelButtonText: lang.cancel,
      })
        .then(() => {
          /**修改头像 */
          this.axios
            .post(this.pub.getApi().UpdateUser, {
              imagePath: '',
            })
            .then((resdata) => {
              if (resdata.data.code == 0) {
                this.userInfo.imagePath = '';
              } else {
                this.$notify(lang.editFailure);
              }
            });
        })
        .catch();
    },
    /**改变Switch按钮 修改获得SMS 和 邮件 */
    changeSwitch() {
      let endName = '';
      if (this.editNameValue) {
        endName = this.editNameValue;
      } else if (this.userInfo.nickName) {
        endName = this.userInfo.nickName;
      }
      this.axios
        .post(this.pub.getApi().UpdateUser, {
          // nickName: this.editNameValue,
          nickName: endName,
          isReceiveSMS: this.userInfo.isReceiveSMS,
          isReceiveMessage: this.userInfo.isReceiveMessage,
        })
        .then((resdata) => {
          if (resdata.data.code == 0) {
          } else {
            this.$notify(lang.editFailure);
          }
        });
    },
    /**上传代理证 */
    afterRead(file) {
      if (file.file.size && file.file.size < 20480) {
        this.$notify(lang.fileBig2);
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      if (!this.validateFile(file.file)) {
        this.$notify(lang.fileError);
        return;
      }
      this.axios
        .post(this.pub.getApi().Upload, formData)
        .then((res) => {
          if (res.data.code === 0 && res.data.result) {
            this.agentInfo.agentCardPath = res.data.result[0].url;
          } else {
            this.$notify(lang.picfailure);
          }
        })
        .catch((e) => {
          /**上传失败 */
          this.$notify(lang.picfailure);
        });
    },
    /**oversize 上传图片超出大小*/
    oversize(file) {
      if (!file.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
        /**格式错误 */
        this.editUserPic = false;
        this.$notify(lang.fileError);
      } else {
        /**图片过大 */
        this.editUserPic = false;
        this.$notify(lang.fileBig);
      }
    },
    /**后退 */
    onClickLeft() {
      this.$router.go(-1);
    },
    /**提交更改 修改代理资料 */
    submitEdit() {
      /**验证 */
      /**手机号格式错误*/
      if (this.agentInfo.companyTelephone.length !== 8 || this.agentInfo.companyTelephone[0] == 0 || this.agentInfo.companyTelephone[0] == 1) {
        Notify(lang.telError);
        return;
      }
      /**修改参数 */
      this.agentInfo.isPropertyAgent = true;
      /**修改资料请求 */
      this.axios
        .post(this.pub.getApi().UpdateUser, this.agentInfo)
        .then((res) => {
          if (res.data.code == 0) {
            this.getUserInfo();
          }
        })
        .catch((e) => {
          this.$notify(lang.editFailure);
        });
    },
    //检测数字
    checkInt(field, type) {
      const num = this.agentInfo[field];
      /^$|^\d+$/.test(num) ? (this.cacheNum = num) : (this.agentInfo[field] = this.cacheNum);
    },
    /**关闭地產代理資料*/
    onClickLeftAgent() {
      if (this.userInfo.isPropertyAgent && !this.agentBox) this.agentBox = true;
      else if (this.userInfo.isPropertyAgent && this.agentBox) this.isAgentInformation = 0;
      else if (!this.userInfo.isPropertyAgent && !this.agentBox) this.isAgentInformation = 0;
    },
    // 关闭删除账户
    onClickLeftDelete() {
      this.isAgentInformation = 0;
    },
    /**打开地产代理资料 */
    isAgentClick() {
      this.isAgentInformation = 1;
      if (this.isPc) {
        if (this.isAgentInformation == 1) {
          if (pub.getLang() === 'zh-cn') {
            location.href = `${pub.config.pcPassport}zh-cn/changeagentinfo/`;
          } else if (pub.getLang() === 'en-us') {
            location.href = `${pub.config.pcPassport}en-us/changeagentinfo/`;
          } else {
            location.href = `${pub.config.pcPassport}changeagentinfo/`;
          }
        }
      }
    },
    deleteUser() {
      this.isAgentInformation = 2;
    },
    confirmDelte() {
      this.numFlag++
      if (this.numFlag === 1) {
        this.numFlag = 0;
        window.location.href = `https://wa.me/85257266308?text=${lang.whatsappText}`;
      }

    }
  },
};
</script>
<style lang="scss" scoped>
.fcolor {
    color: #666 !important;
  }
 .agentcontent {
    display: flex;
    justify-content: flex-end;
    padding-top:30px;
    .spanCont{
      display:inline-block;
      height :20px
    }
  }
span.red {
  color: #ed1818;
  font-size: 15px;
  font-weight: 700;
}
.van-field {
  /deep/.van-field__label {
    max-width: 140px;
  }
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.edit-user {
  height: 100%;
  background-color: #f5f6f7;
  font-size: 15px;
  color: #333;
  .nav-edit {
    .van-nav-bar__right {
      .van-nav-bar__text {
        color: #0076ff;
      }
    }
  }

  /deep/.van-uploader__input {
    width: 95%;
  }
  /deep/.edit-up-pic {
    width: 100%;
    height: 100%;
    .avatar-cropper-container {
      overflow: hidden;
      position: relative;
      width: 80%;
      padding-top: 80%;
      margin: 32px auto;
      .width-height {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .btn-edit-pic {
      .van-button {
        margin: 0 16px;
        width: 120px;
        background-color: #fff;
        border: none;
        height: 44px;
        line-height: 44px;
        color: #333;
        font-size: 15px;
      }
      .cancel {
        border: 1px solid #b2b2b2;
        color: #1989fa;
      }
      .comfrim {
        background-color: #ed1c24;
        border: 1px solid #f44;
        color: #fff;
      }
    }
  }
  /*弹出框 */
  /deep/.van-popup.van-popup--bottom.edit-pic {
    background-color: transparent;
    .new-img-uploader {
      .up-img-input {
        display: none;
      }
    }
    .uploader {
      width: 100%;
    }
    .van-button {
      background-color: #fff;
      border: none;
      height: 50px;
      line-height: 50px;
      color: #333;
      font-size: 15px;
      &.choose {
        border-radius: 10px 10px 0 0;
        border-bottom: 1px solid #eee;
      }
      &.remove {
        border-radius: 0 0 10px 10px;
      }
      &.cancel {
        border-radius: 10px;
        margin: 10px 0 1px 0;
      }
    }
  }
  /**弹出框 修改会员名称 */
  /deep/ .van-dialog.edit-user-name {
    .van-dialog__content {
      padding: 16px;
      .van-cell.van-field {
        box-sizing: border-box;
        border: 1px solid #eee;
        .van-field__body input {
          &::placeholder {
            font-size: 12px;
          }
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-wrap: break-word;
        }
      }
    }
  }
  /deep/ .van-dialog.edit-email-notice {
    .van-dialog__content {
      padding: 24px 16px;
      font-size: 15px;
      color: #666;
      p {
        line-height: 24px;
      }
    }
  }
  .user-img.van-cell {
    margin-top: 16px;
    height: 90px;
    line-height: 70px;
    .van-cell__title {
      text-align: left;
    }
    .van-cell__value {
      position: relative;
      img {
        //图片背景
        background-image: url('//static.house730.com/m/images/user-default.png');
        background-size: 40px 40px;
        top: 10px;
        right: 30px;
        position: absolute;
        height: 50px;
        width: 50px;
        border-radius: 2px;
        background-color: #ccc;
      }
      .van-icon-arrow {
        color: #b2b2b2;
        font-size: 14px;
      }
    }
  }
  .user-detail {
    .switch-select {
      /deep/ .van-cell__value {
        width: 65px;
      }
      /deep/ .van-cell__title {
        width: calc(100% - 65px);
        text-align: left;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    /deep/ .van-icon-arrow {
      font-size: 14px;
      color: #b2b2b2;
    }
    /deep/ .van-cell {
      &.no-password {
        .van-cell__value {
          color: #0076ff;
        }
      }
      .van-cell__title {
        flex: none !important;
        margin-right: 12px;
        font-size: 15px;
        color: #333;
      }
      .van-cell__value {
        color: #666;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .agency {
    .show-detail {
      .user-card {
        width: 100%;
        height: 120px;
        background: url('./../assets/user-agent-bg.png') center;
        background-size: 100% 100%;
        display: flex;
        padding: 24px 36px 0;
        box-sizing: border-box;
        .user-pic {
          width: 70px;
          height: 70px;
          background-color: #eee;
          margin-right: 16px;
          img {
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 2px;
          }
        }
        .user-card-detail {
          width: calc(100% - 86px);
          color: #fff;
          font-size: 12px;
          line-height: 18px;
          div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .user-name {
            margin-top: 4px;
            font-size: 17px;
            line-height: 24px;
          }
        }
      }
      .user-license {
        padding: 13px 17px;
        background: #f5f6f8;
        font-size: 12px;
        line-height: 16px;
        color: #666;
        border-radius: 0px 0px 24px 24px;
      }
      .agent-detail {
        .van-cell .van-cell__title {
          line-height: 21px;
          font-size: 15px;
          span {
            color: #999;
          }
          .van-cell__label {
            color: #333;
          }
        }
        .company-img.van-cell {
          margin-bottom: 16px;
          // height: 115px;
          line-height: 95px;
          .van-cell__title {
            text-align: left;
            color: #999;
            padding-top: 10px;
            // line-height: 95px;
          }
          .van-cell__value {
            position: relative;
            img {
              background-image: url('//static.house730.com/m/images/none_img.png');
              background-size: 100px 75px;
              top: 10px;
              right: 30px;
              position: absolute;
              height: 75px;
              width: 100px;
              border-radius: 2px;
              background-color: #ccc;
            }
            .van-icon-arrow {
              color: #b2b2b2;
              font-size: 14px;
            }
          }
        }
      }
    }
    .edit-detail {
      .van-cell.van-field {
        padding-top: 0;
        /deep/.van-field__control {
          color: #666;
        }
      }
      .input-title {
        padding: 15px 15px 10px;
        // span.red {
        //   color: #ed1818;
        //   font-size: 15px;
        //   font-weight: 700;
        // }
      }
      .textarea {
        padding: 5px 15px 10px;
        border-bottom: 1px solid #eee;
        position: relative;
        textarea {
          line-height: 24px;
          background-color: #fff;
          padding: 0;
          width: 100%;
          height: 140px;
          border: none;
          resize: none;
          color: #666;
        }
        .textarea-num {
          position: absolute;
          right: 15px;
          bottom: 10px;
          font-size: 13px;
          color: #b2b2b2;
        }
      }
      .div-line {
        width: 100%;
        height: 12px;
        background: #f5f6f7;
        box-shadow: 0px -1px 0px 0px #e6e6e6;
      }
      .agent-pic {
        border-bottom: 1px solid #eee;
        // span.red {
        //   color: #ed1818;
        //   font-size: 15px;
        //   font-weight: 700;
        // }
        .van-cell {
          height: 105px;
          line-height: 85px;
          .van-cell__value {
            img {
              width: 100px;
              height: 75px;
            }
          }
          .van-cell__title {
            line-height: 20px;
            margin-top: 10px;
            div {
              line-height: 22px;
              font-size: 15px;
              color: #333;
            }
            p {
              font-size: 11px;
              line-height: 14px;
              color: #ed1818;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
            }
          }
          .up-agent-input {
            display: none;
          }
          .img-bg {
            margin-right: 12px;
            position: relative;
            top: -2px;
            display: inline-block;
            width: 100px;
            height: 75px;
            background: url('./../assets/agent-bg.png');
            background-size: 100% 100%;
            vertical-align: middle;
          }
        }
      }
    }
    text-align: left;
    background-color: #fff;
    .van-switch-cell {
      margin-bottom: 16px;
    }
    .agency-title {
      font-weight: 700;
    }
    .notice {
      color: #ed1c24;
      font-size: 12px;
      padding: 16px 22px 0;
    }
    .btn-sub {
      padding: 0 16px;
    }
    .van-uploader {
      width: 100%;

      .van-uploader {
        width: 100%;
      }
      .van-cell {
        height: 72px;
        line-height: 52px;
        .van-cell__title {
          text-align: left;
        }
        .van-cell__value {
          position: relative;
          img {
            //图片背景
            background-size: 100% 100%;
            top: 6px;
            right: 30px;
            position: absolute;
            height: 40px;
            width: 40px;
            background-color: #ccc;
          }
        }
      }
    }
  }
  .agent-card {
    width: 100%;
  }
  .user .agent {
    margin-top: 20px;
    text-align: left;
  }
}
.delete-user {
  padding-left: 15px;
  text-align: left;
  margin-top: 20px;
  font-family: PingFangTC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}
.delete-page {
  padding: 0 16px;
  .confirm-delete {
    height: 44px;
    background: #e70e1a;
    border-radius: 4px;
    line-height: 44px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 17px;
    color: #ffffff;
  }
  .delete-page-title {
    font-family: PingFangTC-Semibold;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin: 24px auto;
  }
  .delete-page-info {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    text-align: left;
    line-height: 20px;
  }
}
.company-tips {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #ed1818;
  line-height: 16px;
  margin-top: 6px;
}
</style>
